var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9472 8.42732C10.3942 7.46709 10.8785 6.51934 11.3998 5.58608C11.4043 5.58193 10.3736 5.34044 9.67104 5.71464C9.67353 5.71475 9.8042 6.22672 9.49082 6.56867C9.05808 7.04075 8.23311 6.85747 7.85751 6.53125C7.17712 5.93174 7.30711 5.09681 8.02585 4.19884C8.02449 4.20873 7.54435 3.0014 5.99974 2.39941C4.45479 3.00095 3.97465 4.20884 3.97363 4.19884C4.69225 5.09681 4.82258 5.93186 4.14197 6.53125C3.76659 6.85713 2.94128 7.04098 2.50889 6.56867C2.19539 6.22684 2.32606 5.71509 2.32855 5.71464C1.6261 5.34066 0.595568 5.58204 0.599867 5.5862C1.12096 6.51934 1.6054 7.46709 2.0525 8.42732C4.65356 7.86602 7.34603 7.86602 9.9472 8.42732C9.94709 8.42732 9.94709 8.42732 9.9472 8.42732Z",
    fill: "#FFBC09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrime);
export default __webpack_public_path__ + "static/media/prime.94c066d4.svg";
export { ForwardRef as ReactComponent };